import { dataBulbTrendSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBulbTrendSolid = /*#__PURE__*/createIcon(dataBulbTrendSolid)
export default IconBulbTrendSolid
